/* eslint-disable no-useless-escape */

var awsConstants = {
    identityPoolId: 'us-west-2:7b253d76-15db-468c-bda2-703a8b1135df',
    userPoolId: 'us-west-2_BZZ2U7HJy',
    region: 'us-west-2',
    clientId: '6bhfo8ouflb4cubushonbtnbpg',
    getPoolData: function () {
        return { UserPoolId: this.userPoolId, ClientId: this.clientId };
    },
    AWSPasswordRegex: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[\^\$\*\.\[\]\{\}\(\)\?\-'!@#%&\/,><':;\|_~])/,
    cognitoLoginObjectKey: 'cognito-idp.us-west-2.amazonaws.com/us-west-2_BZZ2U7HJy'
};

var serverConstants = {
    availableLocales: ['en', 'ja', 'fr', 'es', 'de', 'zh', 'it', 'pt']
};

if (['production', 'sandbox'].includes(process.env.NODE_ENV)) {
    awsConstants.buckets = {std: 'rayz-firmware', act: 'rayz-firmware-act'};
} else {
    awsConstants.buckets = {std: 'rayz-firmware-dev', act: 'rayz-firmware-act-dev'};
}

module.exports = {
    awsConstants: awsConstants,
    serverConstants: serverConstants
};

